<template>
    <div class="grid grid-cols-3 text-center font-bold cursor-pointer select-none mt-2 pt-7 " v-show="isShowCode">
        <div class="border-b-2 py-1 border-im-gray-d9d9d9 text-im-gray-767676"
             :class="[serialType == 'QR_CODE' ? classActiveTab : '']"
             @click="changeTab('QR_CODE')">
            {{lbl.iimmpact.serial.qr_code}}
        </div>
        <div class="border-b-2 py-1 border-im-gray-d9d9d9 text-im-gray-767676"
             :class="[serialType == 'CODE_128' ? classActiveTab : '']"
             @click="changeTab('CODE_128')">
            {{lbl.iimmpact.serial.barcode}}
        </div>
        <div class="border-b-2 py-1 border-im-gray-d9d9d9 text-im-gray-767676"
             :class="[serialType == 'CODE' ? classActiveTab : '']"
             @click="changeTab('CODE')">
            {{lbl.iimmpact.serial.code}}
        </div>
    </div>
    <!-- <div><PrivilegeMessage class="pt-16" :purchase="purchase"></PrivilegeMessage></div> -->
    <div class="pt-16 text-center text-im-gray-767676 text-14">Thank you here is your redemption</div>
    <div class="flex justify-center items-center wrap-code">
        <div v-show="serialType == 'QR_CODE'">
            <VueQrcode :value="serial" :options="qrOption"></VueQrcode>
        </div>
        <div v-show="serialType == 'CODE_128'">
            <VueBarcode :value="serial" :options="barcodeOption"></VueBarcode>
        </div>
        <div v-show="serialType == 'CODE'" class="flex flex-col items-center">
            <div class="max-w-xs text-32 font-bold text-center tracking-2 break-words">{{serial}}</div>
            <button class="border border-im-black-232323 rounded-full py-1.5 px-2 text-center text-im-black-232323 mt-6 text-14"
                v-clipboard:copy="serial"
                v-clipboard:success="onCopy($event)">{{lbl.iimmpact.serial.copy_code}}</button>
        </div>
    </div>
    <div class="flex pt-8" v-show="serialType == 'QR_CODE' || serialType == 'CODE_128'">
        <div class="font-bold text-20 text-im-black-232323 bg-im-gray-efefef p-4 rounded-10 mx-auto">
            PIN : <span class="tracking-2">{{ purchase.iimmpactPin }}</span>
        </div>
    </div>
</template>
<script>
//lib
import VueBarcode from '@chenfengyuan/vue-barcode';
import VueQrcode from '@chenfengyuan/vue-qrcode';
//component
// import PrivilegeMessage from "./PrivilegeMessage.vue";
//feature
import { useLocale } from "@/feature/LocaleFeature"

export default {
    setup: function() {
        const { lbl } = useLocale()
        return {
            lbl,
        }
    },
    name: "Serial",
    components: {
        VueBarcode,
        VueQrcode,
        // PrivilegeMessage,
    },
    props: {
        purchase: Object,
    },
    data: function() {
        return {
            serialType: 'CODE', // CODE, QR_CODE, CODE_128
            classActiveTab: 'text-im-black-232323 border-im-black-232323',

            isExpired: false,
            isLoaded: false,
            isShowCode: true,
            isTabLock: false,
            privilegeMsg: '',
            serial: null,

            qrOption: {
                width: 160,
                margin: 0,
            },
            barcodeOption: {
                height: 100,
                displayValue: false,
                lineColor: '#000000',
                width: 1,
            },
            serialIimmpact: '',
        };
    },
    created: function() {
        this.initial();
    },
    methods: {
        initial: function () {
            if (!this.purchase.serial) {
                return;
            }

            this.isExpired = false;
            this.serialIimmpact = this.purchase.iimmpactPin;
            this.serial = this.serialIimmpact;
            switch (this.purchase.barcode) {
                case 'CODE_128':
                    this.serialType = 'CODE_128';
                    break;
                case 'QR_CODE':
                    this.serialType = 'QR_CODE';
                    break;
                default:
                    this.serialType = 'CODE';
                    break;
            }

            if (this.purchase.barcode && this.purchase.barcode.toLowerCase() == 'none' && this.purchase.privilegeMessage) {
                this.isShowCode = false;
            }
        },

        changeTab: function (type) {
            if (this.isTabLock) return;

            this.serialType = type;
        },

        setSerialExpire: function() {
            this.serial = "XXXXXX";
            this.isExpired = true;
            this.isTabLock = true;
            this.serialType = "CODE";
        },
        onCopy: function() {
            // on copy serial event
        },
    },
}
</script>
<style lang="scss" scoped>
.wrap-code {
    height: 200px;
}

.tab-code {
    max-width: 300px;
}
</style>
